import { useState } from "react";
import { DollarSign, CalendarDays, Split } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { useConfig } from "./ConfiguracoesLayout";
import ConfigSection, { inputClass } from "./ConfigSection";

const Pagamento = () => {
  const { form, update } = useConfig();
  const [showMpToken, setShowMpToken] = useState(false);

  return (
    <div className="space-y-6">
      <ConfigSection title="Pagamentos / MercadoPago" icon={DollarSign}>
        <div className="p-3 rounded-lg bg-secondary/50 text-sm text-muted-foreground mb-2">
          Configure suas credenciais do MercadoPago para receber pagamentos diretamente na sua conta.
          Obtenha suas credenciais em{" "}
          <a href="https://www.mercadopago.com.br/developers/panel/app" target="_blank" rel="noopener noreferrer" className="text-primary underline">
            mercadopago.com.br/developers
          </a>{" "}
          → Suas integrações → Credenciais de produção.
        </div>
        <div className="space-y-2">
          <Label>Access Token</Label>
          <div className="flex gap-2">
            <Input
              type={showMpToken ? "text" : "password"}
              value={form.mp_access_token}
              onChange={(e) => update("mp_access_token", e.target.value)}
              className={inputClass}
              placeholder="APP_USR-..."
            />
            <Button
              type="button"
              variant="outline"
              size="sm"
              className="h-11 px-3 shrink-0"
              onClick={() => setShowMpToken(!showMpToken)}
            >
              {showMpToken ? "Ocultar" : "Mostrar"}
            </Button>
          </div>
          <p className="text-[11px] text-muted-foreground">Token de produção usado para processar pagamentos reais.</p>
        </div>
        <div className="space-y-2">
          <Label>Public Key (opcional)</Label>
          <Input
            value={form.mp_public_key}
            onChange={(e) => update("mp_public_key", e.target.value)}
            className={inputClass}
            placeholder="APP_USR-..."
          />
          <p className="text-[11px] text-muted-foreground">Chave pública para checkout transparente (opcional).</p>
        </div>
      </ConfigSection>

      <ConfigSection title="Funcionalidades de Pedido" icon={CalendarDays}>
        <div className="space-y-4">
          <div className="flex items-center justify-between p-3 rounded-lg border border-border">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center">
                <CalendarDays className="h-4.5 w-4.5 text-primary" />
              </div>
              <div>
                <p className="text-sm font-medium">Agendamento de Pedidos</p>
                <p className="text-[11px] text-muted-foreground">Clientes podem agendar pedidos para data e horário futuro</p>
              </div>
            </div>
            <Switch
              checked={form.scheduled_orders_enabled}
              onCheckedChange={(v) => update("scheduled_orders_enabled", v)}
            />
          </div>

          <div className="flex items-center justify-between p-3 rounded-lg border border-border">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center">
                <Split className="h-4.5 w-4.5 text-primary" />
              </div>
              <div>
                <p className="text-sm font-medium">Dividir Conta (Split)</p>
                <p className="text-[11px] text-muted-foreground">Clientes podem calcular divisão de conta no checkout</p>
              </div>
            </div>
            <Switch
              checked={form.split_payment_enabled}
              onCheckedChange={(v) => update("split_payment_enabled", v)}
            />
          </div>
        </div>
      </ConfigSection>
    </div>
  );
};

export default Pagamento;
